import { PersonalDetails } from 'cpie-common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-15/frontend-integration';
import { fetchMyProfile } from './MyProfileSlice';
import { MyProfileDataSelector } from './MyProfileDataSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-15/common-utilities';

export function useMyProfile(): AbstractDataState<PersonalDetails, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchMyProfile, MyProfileDataSelector);
}
